export const RECAPTCHA_SITE_KEY = "6Lc1ScIoAAAAABFLrhCVFfrv8ca7pqAifhL_K1Ni";
